import { useContext, useState } from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';

import { PublicPage } from '../../shared/PublicPage';
import { Auth0Redirect } from './Auth0Redirect';
import { CheckAuth } from './CheckAuth';
import { CheckEmail } from './CheckEmail';
import { ChooseAuth } from './ChooseAuth';
import { EnterEmail } from './EnterEmail';
import { EnterPassword } from './EnterPassword';
import { ExistingAccount } from './ExistingAccount';
import { LoginContext } from './LoginContext';
import { MagicLink } from './MagicLink';
import { ReleaseHubHeader } from './ReleaseHubHeader';
import { SetNewPassword } from './SetNewPassword';
import { ROUTES } from './constants';

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const EmailRequiredRoute = props => {
  const { email } = useContext(LoginContext);
  if (!email) {
    return <Redirect to={ROUTES.LOGIN} />;
  }

  return <Route {...props} />;
};

const NewLogin = () => {
  const { path } = useRouteMatch();
  const [email, setEmail] = useState('');
  const [desiredDestination, setDesiredDestination] = useState(null);

  const runningOnCircle = window.location.hostname === 'numbox-frontend';

  return (
    <LoginContext.Provider
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Dispatch<SetStateAction<null>>' is not assig... Remove this comment to see the full error message
      value={{ email, setEmail, desiredDestination, setDesiredDestination }}
    >
      <PublicPage banner={<ReleaseHubHeader />}>
        <Switch>
          <Route
            key="magic-auth"
            path={`${path}/auth_link`}
            // @ts-expect-error - Route type mismatch with react-router-dom
            component={MagicLink}
          />

          <Route
            key="magic-auth"
            path={`${path}/auth_link_web`}
            // @ts-expect-error - Route type mismatch with react-router-dom
            component={MagicLink}
          />

          <Route
            // @ts-expect-error - Route type mismatch with react-router-dom
            exact
            key="existing-account"
            path={`${path}/existing_account`}
            component={ExistingAccount}
          />

          <Route
            // @ts-expect-error - Route type mismatch with react-router-dom
            exact
            key="auth0-redirect"
            path={`${path}/auth0redirect`}
            component={Auth0Redirect}
          />

          <EmailRequiredRoute
            key="choose"
            path={`${path}${ROUTES.CHOOSE_AUTH}`}
            component={ChooseAuth}
          />

          <EmailRequiredRoute
            key="check-email"
            path={`${path}${ROUTES.CHECK_EMAIL}`}
            component={CheckEmail}
          />

          <EmailRequiredRoute
            key="password"
            path={`${path}${ROUTES.ENTER_PASSWORD}`}
            component={EnterPassword}
          />

          <Route
            key="set-new-password"
            // @ts-expect-error - Route type mismatch with react-router-dom

            component={SetNewPassword}
            path={`${path}${ROUTES.SET_NEW_PASSWORD}`}
          />

          {import.meta.env.VITE_AUTH0_ENABLED === 'true' && !runningOnCircle ? (
            // @ts-expect-error - Route type mismatch with react-router-dom
            <Route key="check-auth" component={CheckAuth} />
          ) : (
            // @ts-expect-error - Route type mismatch with react-router-dom
            <Route key="enter-email" component={EnterEmail} />
          )}
        </Switch>
      </PublicPage>
    </LoginContext.Provider>
  );
};

export default NewLogin;
